import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data || {});
      if (data?.seo_title) document.title = data.seo_title;
    } catch {}
  }, []);

  useEffect(() => { load(); }, [load]);

  return <SettingsContext.Provider value={{ settings, reload: load }}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
